import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_Subsession = _resolveComponent("Subsession")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    ref: "sidebar",
    title: _ctx.$t('components.sidebar.edit-logo-seals')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Alert, {
        "class-style": "alert tray-theme-editor__settings-editor__alert",
        "input-fields": {
        label: _ctx.$t('components.modals.titles.attention') + ':',
        description: _ctx.$t('components.alert.changes-edit-logo-seal'),
      },
        icon: true
      }, null, 8, ["input-fields"]),
      _createVNode(_component_Subsession, {
        dropdown: _ctx.dropdown,
        "onUpdate:dropdown": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dropdown) = $event)),
        "title-subsession": _ctx.$t('layout-editor.logo')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageListLogo, (logoImage, index) => {
            return (_openBlock(), _createBlock(_component_InputFile, {
              key: index,
              "test-key": logoImage.key,
              class: "inputfile-edit-logo-seals",
              "input-fields": {
          label: _ctx.$t(`components.logo.inputs-file.${logoImage.key}.title`),
          field: _ctx.$t(`components.logo.inputs-file.${logoImage.key}.name`),
          description: [
            _ctx.$t(`components.logo.inputs-file.${logoImage.key}.tooltip-info`),
          ],
          validation: '',
          type: '',
        },
              "url-image": logoImage.url,
              onCallback: _ctx.updateLogo
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1032, ["test-key", "input-fields", "url-image", "onCallback"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["dropdown", "title-subsession"]),
      _createVNode(_component_Subsession, {
        dropdown: _ctx.dropdown,
        "onUpdate:dropdown": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dropdown) = $event)),
        "title-subsession": _ctx.$t('layout-editor.seals')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageListSeals, (sealImage, index) => {
            return (_openBlock(), _createBlock(_component_InputFile, {
              key: index,
              "test-key": sealImage.key,
              "input-fields": {
          label: _ctx.$t(`components.seal.inputs-file.${sealImage.key}.title`),
          field: _ctx.$t(`components.seal.inputs-file.${sealImage.key}.name`),
          description: [
            _ctx.$t(`components.seal.inputs-file.${sealImage.key}.tooltip-info`),
          ],
          validation: '',
          type: '',
        },
              "url-image": sealImage.url,
              onCallback: _ctx.updateSeal
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["test-key", "input-fields", "url-image", "onCallback"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["dropdown", "title-subsession"])
    ]),
    _: 1
  }, 8, ["title"]))
}